/* eslint-disable max-len */
import update from 'immutability-helper';
import { NOC_METRICS } from '@utils/metrics';
import { CURRENT_PRODUCT_MODE, DEFAULT_SORT } from '@utils/constants';
import * as filterTypes from '@store/filterContainer/types';
import * as types from './types';
import { DEFAULT_DIMENSION } from '@components/noc-metric-panel/utils/constants';

// eslint-disable-next-line arrow-parens
export const setTempIdToFilters = (filters) =>
  filters.map((filter) => {
    // eslint-disable-next-line no-param-reassign
    filter.key = filter.key
      ? filter.key
      : Math.floor(Math.random() * (Date.now() - 10000 + 1) + 10000);
    return filter;
  });

const initialState = {
  // mode is set by saga after checking persistence
  mode: '',
  filters: {
    // default filter is loaded on init
    appliedFilter: [],
    metrics: NOC_METRICS[CURRENT_PRODUCT_MODE],
    sort: DEFAULT_SORT,
  },
  trends: {
    appliedFilter: [],
    dimension: DEFAULT_DIMENSION[CURRENT_PRODUCT_MODE],
    metrics: NOC_METRICS[CURRENT_PRODUCT_MODE],
    sort: DEFAULT_SORT,
  },
  unsavedThresholdChanges: false,
  allThresholdSelection: false,
  isAdminRole: false,
  isAutoSortEnabled: true,
  isRedirectedFromNocTiles: false,
};

const switchMap = {};

switchMap[types.INIT] = (state) =>
  update(state, {
    $set: initialState,
  });

switchMap[types.SET_PERSISTED_STATE] = (state, action) => {
  const { base } = action;
  return update(state, {
    $set: base,
  });
};

switchMap[types.SET_DIMENSION] = (state, action) =>
  update(state, {
    trends: {
      dimension: { $set: action.dimension },
    },
  });

switchMap[types.SET_MODE] = (state, action) =>
  update(state, {
    mode: { $set: action.mode },
  });

switchMap[types.SET_TRENDS_METRICS] = (state, action) =>
  update(state, {
    trends: {
      metrics: { $set: action.metrics },
    },
  });

switchMap[types.SET_FILTERS_METRICS] = (state, action) =>
  update(state, {
    filters: {
      metrics: { $set: action.metrics },
    },
  });

switchMap[types.SET_TABLE_DATA] = (state, action) =>
  update(state, {
    trends: {
      dimension: { $set: action.dimension },
    },
  });

switchMap[types.SAVE_THRESHOLD_CHANGE_STATUS] = (state, action) =>
  update(state, {
    unsavedThresholdChanges: {
      $set: action.hasUnsavedChanges,
    },
  });

switchMap[types.SET_ALL_THRESHOLD_SELECTION] = (state, action) =>
  update(state, {
    allThresholdSelection: {
      $set: action.selection,
    },
  });

switchMap[types.SET_ADMIN_PROFILE] = (state, action) =>
  update(state, {
    isAdminRole: {
      $set: action.isAdmin,
    },
  });

switchMap[types.APPLY_TRENDS_SELECTED_NOC_FILTERS] = (state, action) => {
  const { filters } = action;
  const newFilters = setTempIdToFilters(filters);
  return update(state, {
    trends: {
      appliedFilter: { $set: newFilters },
    },
  });
};

switchMap[types.APPLY_FILTERS_SELECTED_NOC_FILTERS] = (state, action) => {
  const { filters } = action;
  const newFilters = setTempIdToFilters(filters);
  return update(state, {
    filters: {
      appliedFilter: { $set: newFilters },
    },
  });
};

switchMap[types.UPDATE_SAVED_FILTERS_SELECTED_NOC_FILTERS] = (state, action) => {
  const { filters } = action;
  const {
    filters: { appliedFilter },
  } = state;
  const adhocFilters = appliedFilter.filter((filter) => !filter.fid);
  const newFilters = setTempIdToFilters(filters);
  const mergedFilters = [...adhocFilters, ...newFilters];
  return update(state, {
    filters: {
      appliedFilter: { $set: mergedFilters },
    },
  });
};

switchMap[types.SET_TRENDS_SORTING] = (state, action) => {
  const { sort } = action;
  return update(state, {
    trends: {
      sort: { $set: sort },
    },
  });
};

switchMap[types.SET_FILTERS_SORTING] = (state, action) => {
  const { sort } = action;
  return update(state, {
    filters: {
      sort: { $set: sort },
    },
  });
};

// load default filters (All Traffic)
switchMap[filterTypes.SET_DEFAULT_FILTERS] = (state, action) => {
  const { filters } = action;
  const newFilters = setTempIdToFilters(filters);

  // update initial state
  // to do valid resets later
  initialState.filters.appliedFilter = newFilters;
  initialState.trends.appliedFilter = newFilters;

  return update(state, {
    filters: {
      appliedFilter: { $set: newFilters },
    },
    trends: {
      appliedFilter: { $set: newFilters },
    },
  });
};

switchMap[types.SET_AUTO_SORT] = (state, action) =>
  update(state, {
    $merge: { isAutoSortEnabled: action.isAutoSortEnabled },
  });

switchMap[types.SET_REDIRECTED_FROM_NOC_TILE] = (state, action) =>
  update(state, {
    $merge: { isRedirectedFromNocTiles: action.isRedirectedFromNocTiles },
  });

export default (state = initialState, action) =>
  switchMap[action.type] ? switchMap[action.type](state, action) : state;
